import {React} from "react";
import "./WordGrid.css"; 
import { Link } from "react-router-dom";


export default function WordGrid({ data, title, dictLink, onSelectItem}) {
  
  console.log("WordGrid props:", { data, title, dictLink, onSelectItem });//test log
  
  return (
      
    <div className="word-grid-container">
      {/* Header appears once */}
      <h2 className="grid-title">{title}</h2>

    <div className="grid-cards">
     
      {data.map((item, index) => (
       
       <Link to={item.dictLink} key={index} className="grid-card">
        
          <div onClick={(e) => {
          
          e.preventDefault(); // prevent navigation if only want popup
           
          onSelectItem(item);
          
          }}>
            
            <div className="korean">{item.korean}</div>
           
            <div className="english">{item.english}</div>
         
          </div>
        
        </Link>
     ))}  
    </div>   
    </div>
);
}
